import { getRouterSelectors } from '@ngrx/router-store';
import { createSelector } from '@ngrx/store';

import { PageType } from '../../../shared/pageType';
import { selectAllRouteParams } from '../../../shared/store/selectors/router';
import { GatewayId } from '../../../site-gateway/models/gateway';
import { DeviceId } from '../../models/Device';

export const { selectRouteData } = getRouterSelectors();

export type SiteRouteContext = {
    gatewayId: GatewayId;
    deviceId: DeviceId | null;
    pageType: PageType;
} | null;

export const getSiteDetailRouteContext = createSelector(
    selectAllRouteParams,
    selectRouteData,
    (params, data): SiteRouteContext => ({
        gatewayId: params?.['gatewayId'] ?? null,
        deviceId: params?.['deviceId'] ?? null,
        pageType: data?.['pageType'] ?? null,
    }),
);
